export default {
  start: {
    name: 'start',
    type: 'SimpleText',
    excludeNavigation: true,
    headline: 'Webdeveloper seit 2005',
    text: `Mein Name ist Tim Vogt. Ich bin Softwareentwickler aus Leidenschaft. Seit mehr als 15 Jahren beschäftige ich mich mit den aktuellen Webtechnologien.`
  },
  about: {
    name: 'about',
    type: 'MediaList',
    headline: 'Über mich',
    image: {
      url: '/img/tim_vogt.jpg',
      title: 'Tim Vogt',
      alt: 'Bild von Tim Vogt'
    },
    data: [
      { text: `geboren 1980` },
      { text: `Abitur 2002` },
      { text: `Mediengestalter (Operating) 2008` },
      { text: `Selbständiger Softwareentwickler 2008` }
    ]
  },
  skills: {
    name: 'skills',
    type: 'FeatureList',
    headline: 'Skills',
    data: [
      { text: 'php' },
      { text: 'MySql' },
      { text: 'Node JS' },
      { text: 'Typescript' },
    ]
  },
  frameworks: {
    name: 'frameworks',
    type: 'FeatureList',
    headline: 'Frameworks',
    data: [
      { text: 'Vue.js' },
      { text: 'Angular' },
      { text: 'Symfony' },
      { text: 'Bootstrap' },
      { text: 'jQuery' },
    ]
  },
  systems: {
    name: 'systems',
    type: 'FeatureList',
    headline: 'Systeme',
    data: [
      { text: 'Grav' },
      { text: 'Contao' },
      { text: 'Leeflets' },
      { text: 'Typo3' },
    ]
  },
  clients: {
    name: 'clients',
    type: 'FeatureList',
    headline: 'Kunden',
    data: [
      { text: 'Artseid' },
      { text: 'Art und Design' },
      { text: 'BMW' },
      { text: 'i-Talk24' },
      { text: 'Universal Music' },
      { text: 'Whatpeopleplay' }
    ]
  },
  contact: {
    name: 'contact',
    type: 'SimpleText',
    headline: 'Kontakt',
    text: `Tim Vogt<br>
    Dreeblöcken 68<br>
    23570 Lübeck<br>
    <br>
    Tel. <a href="tel:+4945027706050">04502 / 770 60 50</a><br>
    E-Mail: <a href="mailto:tv@page6.de">tv@page6.de</a><br>
    USt.-Id. Nr.: DE302302527`
  },
}
